  var sku_values_l = ''; //Valor de todas las combinaciones colocadas en el ojo izquierdo
  var sku_values_r = ''; //Valor de todas las combinaciones colocadas en el ojo derecho
  var var_l_sph = ''; //Este es el valor del SPH en el ojo izquierdo
  var var_r_sph = ''; //Este es el valor del SPH en el ojo derecho
  var var_l_add = ''; //Este es el valor del ADD en el ojo izquierdo
  var var_r_add = ''; //Este es el valor del ADD en el ojo derecho

$('#right-upc input, #left-upc input').val(val_upc);
    
$('#left-graduacion').click(function() {
    var_l_sph = $('#7135668994242_option_4').val();
    console.log(var_l_sph); 
    unify_values_l();
    fetch_sku_l();
});

$('#left-add').click(function() {
    var_l_add = $('#7135668994242_option_6').val();
    console.log(var_l_add); 
    unify_values_l();
    fetch_sku_l();
});

$('#right-graduacion').click(function() {
    var_r_sph = $('#7135668994242_option_5').val();
    console.log(var_r_sph); 
    unify_values_r();
    fetch_sku_r();
});

$('#right-add').click(function() {
    var_r_add = $('#7135668994242_option_7').val();
    console.log(var_r_add); 
    unify_values_r();
    fetch_sku_r();
});

function unify_values_l(){
    sku_values_l = var_l_sph + var_l_add;
    console.log(sku_values_l);
}

function unify_values_r(){
    sku_values_r = var_r_sph + var_r_add;
    console.log(sku_values_r);
}

function fetch_sku_l(){
    switch (sku_values_l) { 

case '-9.75High (+2.25D a +2.50D)' : $('#left-sku input').val('310709'); break;
case '-9.25High (+2.25D a +2.50D)' : $('#left-sku input').val('310703'); break;
case '-8.75High (+2.25D a +2.50D)' : $('#left-sku input').val('310697'); break;
case '-8.25High (+2.25D a +2.50D)' : $('#left-sku input').val('310691'); break;
case '-9.75Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310711'); break;
case '-9.25Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310705'); break;
case '-8.75Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310699'); break;
case '-8.25Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310693'); break;
case '-9.75Low (Hasta +1.25D)' : $('#left-sku input').val('310710'); break;
case '-9.25Low (Hasta +1.25D)' : $('#left-sku input').val('310704'); break;
case '-8.75Low (Hasta +1.25D)' : $('#left-sku input').val('310698'); break;
case '-8.25Low (Hasta +1.25D)' : $('#left-sku input').val('310692'); break;
case '-10.00High (+2.25D a +2.50D)' : $('#left-sku input').val('310712'); break;
case '-9.50High (+2.25D a +2.50D)' : $('#left-sku input').val('310706'); break;
case '-9.00High (+2.25D a +2.50D)' : $('#left-sku input').val('310700'); break;
case '-8.50High (+2.25D a +2.50D)' : $('#left-sku input').val('310694'); break;
case '-8.00High (+2.25D a +2.50D)' : $('#left-sku input').val('310688'); break;
case '-7.75High (+2.25D a +2.50D)' : $('#left-sku input').val('310685'); break;
case '-7.50High (+2.25D a +2.50D)' : $('#left-sku input').val('310682'); break;
case '-7.25High (+2.25D a +2.50D)' : $('#left-sku input').val('310679'); break;
case '-7.00High (+2.25D a +2.50D)' : $('#left-sku input').val('310676'); break;
case '-6.75High (+2.25D a +2.50D)' : $('#left-sku input').val('310673'); break;
case '-6.50High (+2.25D a +2.50D)' : $('#left-sku input').val('310670'); break;
case '-6.25High (+2.25D a +2.50D)' : $('#left-sku input').val('310667'); break;
case '-6.00High (+2.25D a +2.50D)' : $('#left-sku input').val('310664'); break;
case '-5.75High (+2.25D a +2.50D)' : $('#left-sku input').val('310661'); break;
case '-5.50High (+2.25D a +2.50D)' : $('#left-sku input').val('310658'); break;
case '-5.25High (+2.25D a +2.50D)' : $('#left-sku input').val('310655'); break;
case '-5.00High (+2.25D a +2.50D)' : $('#left-sku input').val('310652'); break;
case '-4.75High (+2.25D a +2.50D)' : $('#left-sku input').val('310649'); break;
case '-4.50High (+2.25D a +2.50D)' : $('#left-sku input').val('310646'); break;
case '-4.25High (+2.25D a +2.50D)' : $('#left-sku input').val('310643'); break;
case '-4.00High (+2.25D a +2.50D)' : $('#left-sku input').val('310640'); break;
case '-3.75High (+2.25D a +2.50D)' : $('#left-sku input').val('310637'); break;
case '-3.50High (+2.25D a +2.50D)' : $('#left-sku input').val('310634'); break;
case '-3.25High (+2.25D a +2.50D)' : $('#left-sku input').val('310631'); break;
case '-3.00High (+2.25D a +2.50D)' : $('#left-sku input').val('310628'); break;
case '-2.75High (+2.25D a +2.50D)' : $('#left-sku input').val('310625'); break;
case '-2.50High (+2.25D a +2.50D)' : $('#left-sku input').val('310622'); break;
case '-2.25High (+2.25D a +2.50D)' : $('#left-sku input').val('310619'); break;
case '-2.00High (+2.25D a +2.50D)' : $('#left-sku input').val('310616'); break;
case '-1.75High (+2.25D a +2.50D)' : $('#left-sku input').val('310613'); break;
case '-1.50High (+2.25D a +2.50D)' : $('#left-sku input').val('310610'); break;
case '-1.25High (+2.25D a +2.50D)' : $('#left-sku input').val('310607'); break;
case '-1.00High (+2.25D a +2.50D)' : $('#left-sku input').val('310604'); break;
case '-0.75High (+2.25D a +2.50D)' : $('#left-sku input').val('310601'); break;
case '-0.50High (+2.25D a +2.50D)' : $('#left-sku input').val('310598'); break;
case '-0.25High (+2.25D a +2.50D)' : $('#left-sku input').val('310595'); break;
case '-0.00High (+2.25D a +2.50D)' : $('#left-sku input').val('310592'); break;
case '+0.25High (+2.25D a +2.50D)' : $('#left-sku input').val('310520'); break;
case '+0.50High (+2.25D a +2.50D)' : $('#left-sku input').val('310523'); break;
case '+0.75High (+2.25D a +2.50D)' : $('#left-sku input').val('310526'); break;
case '+1.00High (+2.25D a +2.50D)' : $('#left-sku input').val('310529'); break;
case '+1.25High (+2.25D a +2.50D)' : $('#left-sku input').val('310532'); break;
case '+1.50High (+2.25D a +2.50D)' : $('#left-sku input').val('310535'); break;
case '+1.75High (+2.25D a +2.50D)' : $('#left-sku input').val('310538'); break;
case '+2.00High (+2.25D a +2.50D)' : $('#left-sku input').val('310541'); break;
case '+2.25High (+2.25D a +2.50D)' : $('#left-sku input').val('310544'); break;
case '+2.50High (+2.25D a +2.50D)' : $('#left-sku input').val('310547'); break;
case '+2.75High (+2.25D a +2.50D)' : $('#left-sku input').val('310550'); break;
case '+3.00High (+2.25D a +2.50D)' : $('#left-sku input').val('310553'); break;
case '+3.25High (+2.25D a +2.50D)' : $('#left-sku input').val('310556'); break;
case '+3.50High (+2.25D a +2.50D)' : $('#left-sku input').val('310559'); break;
case '+3.75High (+2.25D a +2.50D)' : $('#left-sku input').val('310562'); break;
case '+4.00High (+2.25D a +2.50D)' : $('#left-sku input').val('310565'); break;
case '+4.25High (+2.25D a +2.50D)' : $('#left-sku input').val('310568'); break;
case '+4.50High (+2.25D a +2.50D)' : $('#left-sku input').val('310571'); break;
case '+4.75High (+2.25D a +2.50D)' : $('#left-sku input').val('310574'); break;
case '+5.00High (+2.25D a +2.50D)' : $('#left-sku input').val('310577'); break;
case '+5.25High (+2.25D a +2.50D)' : $('#left-sku input').val('310580'); break;
case '+5.50High (+2.25D a +2.50D)' : $('#left-sku input').val('310583'); break;
case '+5.75High (+2.25D a +2.50D)' : $('#left-sku input').val('310586'); break;
case '+6.00High (+2.25D a +2.50D)' : $('#left-sku input').val('310589'); break;
case '-10.00Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310714'); break;
case '-9.50Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310708'); break;
case '-9.00Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310702'); break;
case '-8.50Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310696'); break;
case '-8.00Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310690'); break;
case '-7.75Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310687'); break;
case '-7.50Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310684'); break;
case '-7.25Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310681'); break;
case '-7.00Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310678'); break;
case '-6.75Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310675'); break;
case '-6.50Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310672'); break;
case '-6.25Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310669'); break;
case '-6.00Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310666'); break;
case '-5.75Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310663'); break;
case '-5.50Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310660'); break;
case '-5.25Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310657'); break;
case '-5.00Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310654'); break;
case '-4.75Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310651'); break;
case '-4.50Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310648'); break;
case '-4.25Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310645'); break;
case '-4.00Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310642'); break;
case '-3.75Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310639'); break;
case '-3.50Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310636'); break;
case '-3.25Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310633'); break;
case '-3.00Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310630'); break;
case '-2.75Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310627'); break;
case '-2.50Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310624'); break;
case '-2.25Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310621'); break;
case '-2.00Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310618'); break;
case '-1.75Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310615'); break;
case '-1.50Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310612'); break;
case '-1.25Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310609'); break;
case '-1.00Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310606'); break;
case '-0.75Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310603'); break;
case '-0.50Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310600'); break;
case '-0.25Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310597'); break;
case '-0.00Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310594'); break;
case '+0.25Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310522'); break;
case '+0.50Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310525'); break;
case '+0.75Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310528'); break;
case '+1.00Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310531'); break;
case '+1.25Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310534'); break;
case '+1.50Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310537'); break;
case '+1.75Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310540'); break;
case '+2.00Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310543'); break;
case '+2.25Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310546'); break;
case '+2.50Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310549'); break;
case '+2.75Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310552'); break;
case '+3.00Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310555'); break;
case '+3.25Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310558'); break;
case '+3.50Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310561'); break;
case '+3.75Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310564'); break;
case '+4.00Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310567'); break;
case '+4.25Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310570'); break;
case '+4.50Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310573'); break;
case '+4.75Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310576'); break;
case '+5.00Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310579'); break;
case '+5.25Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310582'); break;
case '+5.50Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310585'); break;
case '+5.75Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310588'); break;
case '+6.00Medium (+1.50D a +2.00D)' : $('#left-sku input').val('310591'); break;
case '-10.00Low (Hasta +1.25D)' : $('#left-sku input').val('310713'); break;
case '-9.50Low (Hasta +1.25D)' : $('#left-sku input').val('310707'); break;
case '-9.00Low (Hasta +1.25D)' : $('#left-sku input').val('310701'); break;
case '-8.50Low (Hasta +1.25D)' : $('#left-sku input').val('310695'); break;
case '-8.00Low (Hasta +1.25D)' : $('#left-sku input').val('310689'); break;
case '-7.75Low (Hasta +1.25D)' : $('#left-sku input').val('310686'); break;
case '-7.50Low (Hasta +1.25D)' : $('#left-sku input').val('310683'); break;
case '-7.25Low (Hasta +1.25D)' : $('#left-sku input').val('310680'); break;
case '-7.00Low (Hasta +1.25D)' : $('#left-sku input').val('310677'); break;
case '-6.75Low (Hasta +1.25D)' : $('#left-sku input').val('310674'); break;
case '-6.50Low (Hasta +1.25D)' : $('#left-sku input').val('310671'); break;
case '-6.25Low (Hasta +1.25D)' : $('#left-sku input').val('310668'); break;
case '-6.00Low (Hasta +1.25D)' : $('#left-sku input').val('310665'); break;
case '-5.75Low (Hasta +1.25D)' : $('#left-sku input').val('310662'); break;
case '-5.50Low (Hasta +1.25D)' : $('#left-sku input').val('310659'); break;
case '-5.25Low (Hasta +1.25D)' : $('#left-sku input').val('310656'); break;
case '-5.00Low (Hasta +1.25D)' : $('#left-sku input').val('310653'); break;
case '-4.75Low (Hasta +1.25D)' : $('#left-sku input').val('310650'); break;
case '-4.50Low (Hasta +1.25D)' : $('#left-sku input').val('310647'); break;
case '-4.25Low (Hasta +1.25D)' : $('#left-sku input').val('310644'); break;
case '-4.00Low (Hasta +1.25D)' : $('#left-sku input').val('310641'); break;
case '-3.75Low (Hasta +1.25D)' : $('#left-sku input').val('310638'); break;
case '-3.50Low (Hasta +1.25D)' : $('#left-sku input').val('310635'); break;
case '-3.25Low (Hasta +1.25D)' : $('#left-sku input').val('310632'); break;
case '-3.00Low (Hasta +1.25D)' : $('#left-sku input').val('310629'); break;
case '-2.75Low (Hasta +1.25D)' : $('#left-sku input').val('310626'); break;
case '-2.50Low (Hasta +1.25D)' : $('#left-sku input').val('310623'); break;
case '-2.25Low (Hasta +1.25D)' : $('#left-sku input').val('310620'); break;
case '-2.00Low (Hasta +1.25D)' : $('#left-sku input').val('310617'); break;
case '-1.75Low (Hasta +1.25D)' : $('#left-sku input').val('310614'); break;
case '-1.50Low (Hasta +1.25D)' : $('#left-sku input').val('310611'); break;
case '-1.25Low (Hasta +1.25D)' : $('#left-sku input').val('310608'); break;
case '-1.00Low (Hasta +1.25D)' : $('#left-sku input').val('310605'); break;
case '-0.75Low (Hasta +1.25D)' : $('#left-sku input').val('310602'); break;
case '-0.50Low (Hasta +1.25D)' : $('#left-sku input').val('310599'); break;
case '-0.25Low (Hasta +1.25D)' : $('#left-sku input').val('310596'); break;
case '-0.00Low (Hasta +1.25D)' : $('#left-sku input').val('310593'); break;
case '+0.25Low (Hasta +1.25D)' : $('#left-sku input').val('310521'); break;
case '+0.50Low (Hasta +1.25D)' : $('#left-sku input').val('310524'); break;
case '+0.75Low (Hasta +1.25D)' : $('#left-sku input').val('310527'); break;
case '+1.00Low (Hasta +1.25D)' : $('#left-sku input').val('310530'); break;
case '+1.25Low (Hasta +1.25D)' : $('#left-sku input').val('310533'); break;
case '+1.50Low (Hasta +1.25D)' : $('#left-sku input').val('310536'); break;
case '+1.75Low (Hasta +1.25D)' : $('#left-sku input').val('310539'); break;
case '+2.00Low (Hasta +1.25D)' : $('#left-sku input').val('310542'); break;
case '+2.25Low (Hasta +1.25D)' : $('#left-sku input').val('310545'); break;
case '+2.50Low (Hasta +1.25D)' : $('#left-sku input').val('310548'); break;
case '+2.75Low (Hasta +1.25D)' : $('#left-sku input').val('310551'); break;
case '+3.00Low (Hasta +1.25D)' : $('#left-sku input').val('310554'); break;
case '+3.25Low (Hasta +1.25D)' : $('#left-sku input').val('310557'); break;
case '+3.50Low (Hasta +1.25D)' : $('#left-sku input').val('310560'); break;
case '+3.75Low (Hasta +1.25D)' : $('#left-sku input').val('310563'); break;
case '+4.00Low (Hasta +1.25D)' : $('#left-sku input').val('310566'); break;
case '+4.25Low (Hasta +1.25D)' : $('#left-sku input').val('310569'); break;
case '+4.50Low (Hasta +1.25D)' : $('#left-sku input').val('310572'); break;
case '+4.75Low (Hasta +1.25D)' : $('#left-sku input').val('310575'); break;
case '+5.00Low (Hasta +1.25D)' : $('#left-sku input').val('310578'); break;
case '+5.25Low (Hasta +1.25D)' : $('#left-sku input').val('310581'); break;
case '+5.50Low (Hasta +1.25D)' : $('#left-sku input').val('310584'); break;
case '+5.75Low (Hasta +1.25D)' : $('#left-sku input').val('310587'); break;
case '+6.00Low (Hasta +1.25D)' : $('#left-sku input').val('310590'); break;

        default:
        $('#left-sku input').val('SKU Desconocido');
    }
}//fetch_sku()



function fetch_sku_r(){
    switch (sku_values_r) {
        case '-9.75High (+2.25D a +2.50D)' : $('#right-sku input').val('310709'); break;
case '-9.25High (+2.25D a +2.50D)' : $('#right-sku input').val('310703'); break;
case '-8.75High (+2.25D a +2.50D)' : $('#right-sku input').val('310697'); break;
case '-8.25High (+2.25D a +2.50D)' : $('#right-sku input').val('310691'); break;
case '-9.75Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310711'); break;
case '-9.25Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310705'); break;
case '-8.75Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310699'); break;
case '-8.25Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310693'); break;
case '-9.75Low (Hasta +1.25D)' : $('#right-sku input').val('310710'); break;
case '-9.25Low (Hasta +1.25D)' : $('#right-sku input').val('310704'); break;
case '-8.75Low (Hasta +1.25D)' : $('#right-sku input').val('310698'); break;
case '-8.25Low (Hasta +1.25D)' : $('#right-sku input').val('310692'); break;
case '-10.00High (+2.25D a +2.50D)' : $('#right-sku input').val('310712'); break;
case '-9.50High (+2.25D a +2.50D)' : $('#right-sku input').val('310706'); break;
case '-9.00High (+2.25D a +2.50D)' : $('#right-sku input').val('310700'); break;
case '-8.50High (+2.25D a +2.50D)' : $('#right-sku input').val('310694'); break;
case '-8.00High (+2.25D a +2.50D)' : $('#right-sku input').val('310688'); break;
case '-7.75High (+2.25D a +2.50D)' : $('#right-sku input').val('310685'); break;
case '-7.50High (+2.25D a +2.50D)' : $('#right-sku input').val('310682'); break;
case '-7.25High (+2.25D a +2.50D)' : $('#right-sku input').val('310679'); break;
case '-7.00High (+2.25D a +2.50D)' : $('#right-sku input').val('310676'); break;
case '-6.75High (+2.25D a +2.50D)' : $('#right-sku input').val('310673'); break;
case '-6.50High (+2.25D a +2.50D)' : $('#right-sku input').val('310670'); break;
case '-6.25High (+2.25D a +2.50D)' : $('#right-sku input').val('310667'); break;
case '-6.00High (+2.25D a +2.50D)' : $('#right-sku input').val('310664'); break;
case '-5.75High (+2.25D a +2.50D)' : $('#right-sku input').val('310661'); break;
case '-5.50High (+2.25D a +2.50D)' : $('#right-sku input').val('310658'); break;
case '-5.25High (+2.25D a +2.50D)' : $('#right-sku input').val('310655'); break;
case '-5.00High (+2.25D a +2.50D)' : $('#right-sku input').val('310652'); break;
case '-4.75High (+2.25D a +2.50D)' : $('#right-sku input').val('310649'); break;
case '-4.50High (+2.25D a +2.50D)' : $('#right-sku input').val('310646'); break;
case '-4.25High (+2.25D a +2.50D)' : $('#right-sku input').val('310643'); break;
case '-4.00High (+2.25D a +2.50D)' : $('#right-sku input').val('310640'); break;
case '-3.75High (+2.25D a +2.50D)' : $('#right-sku input').val('310637'); break;
case '-3.50High (+2.25D a +2.50D)' : $('#right-sku input').val('310634'); break;
case '-3.25High (+2.25D a +2.50D)' : $('#right-sku input').val('310631'); break;
case '-3.00High (+2.25D a +2.50D)' : $('#right-sku input').val('310628'); break;
case '-2.75High (+2.25D a +2.50D)' : $('#right-sku input').val('310625'); break;
case '-2.50High (+2.25D a +2.50D)' : $('#right-sku input').val('310622'); break;
case '-2.25High (+2.25D a +2.50D)' : $('#right-sku input').val('310619'); break;
case '-2.00High (+2.25D a +2.50D)' : $('#right-sku input').val('310616'); break;
case '-1.75High (+2.25D a +2.50D)' : $('#right-sku input').val('310613'); break;
case '-1.50High (+2.25D a +2.50D)' : $('#right-sku input').val('310610'); break;
case '-1.25High (+2.25D a +2.50D)' : $('#right-sku input').val('310607'); break;
case '-1.00High (+2.25D a +2.50D)' : $('#right-sku input').val('310604'); break;
case '-0.75High (+2.25D a +2.50D)' : $('#right-sku input').val('310601'); break;
case '-0.50High (+2.25D a +2.50D)' : $('#right-sku input').val('310598'); break;
case '-0.25High (+2.25D a +2.50D)' : $('#right-sku input').val('310595'); break;
case '-0.00High (+2.25D a +2.50D)' : $('#right-sku input').val('310592'); break;
case '+0.25High (+2.25D a +2.50D)' : $('#right-sku input').val('310520'); break;
case '+0.50High (+2.25D a +2.50D)' : $('#right-sku input').val('310523'); break;
case '+0.75High (+2.25D a +2.50D)' : $('#right-sku input').val('310526'); break;
case '+1.00High (+2.25D a +2.50D)' : $('#right-sku input').val('310529'); break;
case '+1.25High (+2.25D a +2.50D)' : $('#right-sku input').val('310532'); break;
case '+1.50High (+2.25D a +2.50D)' : $('#right-sku input').val('310535'); break;
case '+1.75High (+2.25D a +2.50D)' : $('#right-sku input').val('310538'); break;
case '+2.00High (+2.25D a +2.50D)' : $('#right-sku input').val('310541'); break;
case '+2.25High (+2.25D a +2.50D)' : $('#right-sku input').val('310544'); break;
case '+2.50High (+2.25D a +2.50D)' : $('#right-sku input').val('310547'); break;
case '+2.75High (+2.25D a +2.50D)' : $('#right-sku input').val('310550'); break;
case '+3.00High (+2.25D a +2.50D)' : $('#right-sku input').val('310553'); break;
case '+3.25High (+2.25D a +2.50D)' : $('#right-sku input').val('310556'); break;
case '+3.50High (+2.25D a +2.50D)' : $('#right-sku input').val('310559'); break;
case '+3.75High (+2.25D a +2.50D)' : $('#right-sku input').val('310562'); break;
case '+4.00High (+2.25D a +2.50D)' : $('#right-sku input').val('310565'); break;
case '+4.25High (+2.25D a +2.50D)' : $('#right-sku input').val('310568'); break;
case '+4.50High (+2.25D a +2.50D)' : $('#right-sku input').val('310571'); break;
case '+4.75High (+2.25D a +2.50D)' : $('#right-sku input').val('310574'); break;
case '+5.00High (+2.25D a +2.50D)' : $('#right-sku input').val('310577'); break;
case '+5.25High (+2.25D a +2.50D)' : $('#right-sku input').val('310580'); break;
case '+5.50High (+2.25D a +2.50D)' : $('#right-sku input').val('310583'); break;
case '+5.75High (+2.25D a +2.50D)' : $('#right-sku input').val('310586'); break;
case '+6.00High (+2.25D a +2.50D)' : $('#right-sku input').val('310589'); break;
case '-10.00Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310714'); break;
case '-9.50Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310708'); break;
case '-9.00Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310702'); break;
case '-8.50Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310696'); break;
case '-8.00Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310690'); break;
case '-7.75Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310687'); break;
case '-7.50Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310684'); break;
case '-7.25Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310681'); break;
case '-7.00Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310678'); break;
case '-6.75Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310675'); break;
case '-6.50Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310672'); break;
case '-6.25Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310669'); break;
case '-6.00Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310666'); break;
case '-5.75Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310663'); break;
case '-5.50Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310660'); break;
case '-5.25Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310657'); break;
case '-5.00Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310654'); break;
case '-4.75Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310651'); break;
case '-4.50Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310648'); break;
case '-4.25Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310645'); break;
case '-4.00Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310642'); break;
case '-3.75Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310639'); break;
case '-3.50Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310636'); break;
case '-3.25Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310633'); break;
case '-3.00Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310630'); break;
case '-2.75Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310627'); break;
case '-2.50Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310624'); break;
case '-2.25Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310621'); break;
case '-2.00Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310618'); break;
case '-1.75Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310615'); break;
case '-1.50Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310612'); break;
case '-1.25Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310609'); break;
case '-1.00Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310606'); break;
case '-0.75Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310603'); break;
case '-0.50Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310600'); break;
case '-0.25Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310597'); break;
case '-0.00Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310594'); break;
case '+0.25Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310522'); break;
case '+0.50Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310525'); break;
case '+0.75Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310528'); break;
case '+1.00Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310531'); break;
case '+1.25Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310534'); break;
case '+1.50Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310537'); break;
case '+1.75Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310540'); break;
case '+2.00Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310543'); break;
case '+2.25Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310546'); break;
case '+2.50Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310549'); break;
case '+2.75Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310552'); break;
case '+3.00Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310555'); break;
case '+3.25Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310558'); break;
case '+3.50Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310561'); break;
case '+3.75Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310564'); break;
case '+4.00Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310567'); break;
case '+4.25Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310570'); break;
case '+4.50Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310573'); break;
case '+4.75Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310576'); break;
case '+5.00Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310579'); break;
case '+5.25Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310582'); break;
case '+5.50Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310585'); break;
case '+5.75Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310588'); break;
case '+6.00Medium (+1.50D a +2.00D)' : $('#right-sku input').val('310591'); break;
case '-10.00Low (Hasta +1.25D)' : $('#right-sku input').val('310713'); break;
case '-9.50Low (Hasta +1.25D)' : $('#right-sku input').val('310707'); break;
case '-9.00Low (Hasta +1.25D)' : $('#right-sku input').val('310701'); break;
case '-8.50Low (Hasta +1.25D)' : $('#right-sku input').val('310695'); break;
case '-8.00Low (Hasta +1.25D)' : $('#right-sku input').val('310689'); break;
case '-7.75Low (Hasta +1.25D)' : $('#right-sku input').val('310686'); break;
case '-7.50Low (Hasta +1.25D)' : $('#right-sku input').val('310683'); break;
case '-7.25Low (Hasta +1.25D)' : $('#right-sku input').val('310680'); break;
case '-7.00Low (Hasta +1.25D)' : $('#right-sku input').val('310677'); break;
case '-6.75Low (Hasta +1.25D)' : $('#right-sku input').val('310674'); break;
case '-6.50Low (Hasta +1.25D)' : $('#right-sku input').val('310671'); break;
case '-6.25Low (Hasta +1.25D)' : $('#right-sku input').val('310668'); break;
case '-6.00Low (Hasta +1.25D)' : $('#right-sku input').val('310665'); break;
case '-5.75Low (Hasta +1.25D)' : $('#right-sku input').val('310662'); break;
case '-5.50Low (Hasta +1.25D)' : $('#right-sku input').val('310659'); break;
case '-5.25Low (Hasta +1.25D)' : $('#right-sku input').val('310656'); break;
case '-5.00Low (Hasta +1.25D)' : $('#right-sku input').val('310653'); break;
case '-4.75Low (Hasta +1.25D)' : $('#right-sku input').val('310650'); break;
case '-4.50Low (Hasta +1.25D)' : $('#right-sku input').val('310647'); break;
case '-4.25Low (Hasta +1.25D)' : $('#right-sku input').val('310644'); break;
case '-4.00Low (Hasta +1.25D)' : $('#right-sku input').val('310641'); break;
case '-3.75Low (Hasta +1.25D)' : $('#right-sku input').val('310638'); break;
case '-3.50Low (Hasta +1.25D)' : $('#right-sku input').val('310635'); break;
case '-3.25Low (Hasta +1.25D)' : $('#right-sku input').val('310632'); break;
case '-3.00Low (Hasta +1.25D)' : $('#right-sku input').val('310629'); break;
case '-2.75Low (Hasta +1.25D)' : $('#right-sku input').val('310626'); break;
case '-2.50Low (Hasta +1.25D)' : $('#right-sku input').val('310623'); break;
case '-2.25Low (Hasta +1.25D)' : $('#right-sku input').val('310620'); break;
case '-2.00Low (Hasta +1.25D)' : $('#right-sku input').val('310617'); break;
case '-1.75Low (Hasta +1.25D)' : $('#right-sku input').val('310614'); break;
case '-1.50Low (Hasta +1.25D)' : $('#right-sku input').val('310611'); break;
case '-1.25Low (Hasta +1.25D)' : $('#right-sku input').val('310608'); break;
case '-1.00Low (Hasta +1.25D)' : $('#right-sku input').val('310605'); break;
case '-0.75Low (Hasta +1.25D)' : $('#right-sku input').val('310602'); break;
case '-0.50Low (Hasta +1.25D)' : $('#right-sku input').val('310599'); break;
case '-0.25Low (Hasta +1.25D)' : $('#right-sku input').val('310596'); break;
case '-0.00Low (Hasta +1.25D)' : $('#right-sku input').val('310593'); break;
case '+0.25Low (Hasta +1.25D)' : $('#right-sku input').val('310521'); break;
case '+0.50Low (Hasta +1.25D)' : $('#right-sku input').val('310524'); break;
case '+0.75Low (Hasta +1.25D)' : $('#right-sku input').val('310527'); break;
case '+1.00Low (Hasta +1.25D)' : $('#right-sku input').val('310530'); break;
case '+1.25Low (Hasta +1.25D)' : $('#right-sku input').val('310533'); break;
case '+1.50Low (Hasta +1.25D)' : $('#right-sku input').val('310536'); break;
case '+1.75Low (Hasta +1.25D)' : $('#right-sku input').val('310539'); break;
case '+2.00Low (Hasta +1.25D)' : $('#right-sku input').val('310542'); break;
case '+2.25Low (Hasta +1.25D)' : $('#right-sku input').val('310545'); break;
case '+2.50Low (Hasta +1.25D)' : $('#right-sku input').val('310548'); break;
case '+2.75Low (Hasta +1.25D)' : $('#right-sku input').val('310551'); break;
case '+3.00Low (Hasta +1.25D)' : $('#right-sku input').val('310554'); break;
case '+3.25Low (Hasta +1.25D)' : $('#right-sku input').val('310557'); break;
case '+3.50Low (Hasta +1.25D)' : $('#right-sku input').val('310560'); break;
case '+3.75Low (Hasta +1.25D)' : $('#right-sku input').val('310563'); break;
case '+4.00Low (Hasta +1.25D)' : $('#right-sku input').val('310566'); break;
case '+4.25Low (Hasta +1.25D)' : $('#right-sku input').val('310569'); break;
case '+4.50Low (Hasta +1.25D)' : $('#right-sku input').val('310572'); break;
case '+4.75Low (Hasta +1.25D)' : $('#right-sku input').val('310575'); break;
case '+5.00Low (Hasta +1.25D)' : $('#right-sku input').val('310578'); break;
case '+5.25Low (Hasta +1.25D)' : $('#right-sku input').val('310581'); break;
case '+5.50Low (Hasta +1.25D)' : $('#right-sku input').val('310584'); break;
case '+5.75Low (Hasta +1.25D)' : $('#right-sku input').val('310587'); break;
case '+6.00Low (Hasta +1.25D)' : $('#right-sku input').val('310590'); break;

      
        default:
        $('#right-sku input').val('SKU Desconocido');
    }
}//fetch_sku()
